// extracted by mini-css-extract-plugin
export var measureBox = "_dl-0";